import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cn } from '@core/utils'

const DialogTitle = ({
    className,
    ...props
}: React.ComponentProps<typeof DialogPrimitive.Title>) => {
    return (
        <DialogPrimitive.Title
            data-slot="dialog-title"
            className={cn('text-lg font-semibold leading-none', className)}
            {...props}
        />
    )
}

DialogTitle.displayName = 'DialogTitle'

export default DialogTitle
